exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width: 992px) {\n  #content {\n    margin-left: 0px; } }\n\n.feature-container {\n  padding-top: 0px;\n  padding-bottom: 60px; }\n\n.list-item {\n  padding-bottom: 10px; }\n\n.filter-section {\n  height: 35px; }\n\n.import-export-link {\n  float: right;\n  color: #9c9b99;\n  margin-top: 5px;\n  margin-right: 5px; }\n\n.import-export-link:hover {\n  color: #76797E; }\n\n.import-export-link-icon {\n  font-size: 20px;\n  margin-top: 10px;\n  margin-right: 9px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/questionnaires/questionnaires.component.scss
// module id = ../../../../../src/app/components/questionnaires/questionnaires.component.scss
// module chunks = main